import React from 'react';
import Image from 'next/image';
import { useResponsive } from '@aptuno/aptuno-ui';
import { Container, FigureBubble } from './BubbleDecoration.styled';

const BubbleDecoration = () => {
  const { isMobile, isDesktop } = useResponsive();

  return (
    <Container isDesktop={isDesktop}>
      <FigureBubble className="bubble_01">
        <Image
          src="/images/landing-pages/landing-landlord/figures/bubble_big.svg"
          width={isMobile ? 279 : 389}
          height={isMobile ? 188 : 301}
          alt="arrendar inmueble con Aptuno rápido y seguro"
          title="Arrendar Inmueble rápido y seguro | Aptuno"
        />
      </FigureBubble>
      <FigureBubble className="bubble_02">
        <Image
          src="/images/landing-pages/landing-landlord/figures/bubble_big.svg"
          width={isMobile ? 279 : 389}
          height={isMobile ? 188 : 301}
          alt="arrendar apartamento con Aptuno rápido y seguro"
          title="Arrendar Inmueble rápido y seguro | Aptuno"
        />
      </FigureBubble>
      <FigureBubble className="bubble_03">
        <Image
          src="/images/landing-pages/landing-landlord/figures/bubble_big.svg"
          width={isMobile ? 279 : 389}
          height={isMobile ? 188 : 301}
          alt="arrendar casa con Aptuno rápido y seguro"
          title="Arrendar Inmueble rápido y seguro | Aptuno"
        />
      </FigureBubble>
      <FigureBubble className="bubble_04">
        <Image
          src="/images/landing-pages/landing-landlord/figures/bubble_big.svg"
          width={isMobile ? 279 : 389}
          height={isMobile ? 188 : 301}
          alt="arrendar inmueble Aptuno"
          title="Arrendar Inmueble rápido y seguro | Aptuno"
        />
      </FigureBubble>
    </Container>
  );
};

export default BubbleDecoration;
